import { render, staticRenderFns } from "./UiChartMini.vue?vue&type=template&id=265c02b9"
import script from "./UiChartMini.vue?vue&type=script&lang=js"
export * from "./UiChartMini.vue?vue&type=script&lang=js"
import style0 from "./UiChartMini.vue?vue&type=style&index=0&id=265c02b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports